import React from 'react';
import PropTypes from 'prop-types';
import { withAccount } from '@/business-components/operator/account-context.js';

/**
 * 附加权限校验的组件，支持运营和销售
 */
@withAccount
class WithPermission extends React.PureComponent {
  static propTypes = {
    /**
     * 登录态
     */
    loginStatus: PropTypes.object,
    /**
     * 强制拒绝
     */
    reject: PropTypes.bool,
    /**
     * 强制允许
     */
    allow: PropTypes.bool,
    /**
     * 允许的用户，传入用户ID
     */
    allowUser: PropTypes.number,
    /**
     * 有任一权限
     */
    oneOf: PropTypes.arrayOf(PropTypes.number),
    /**
     * 有所有权限
     */
    allOf: PropTypes.arrayOf(PropTypes.number),
    /**
     * 不含以下任意权限
     */
    notOf: PropTypes.arrayOf(PropTypes.number),
    /**
     * 子节点
     */
    children: PropTypes.any,
    /**
     * 自定义perm check 方法
     */
    permCheck: PropTypes.func,
  }

  render() {
    const { account, allOf, oneOf, notOf, reject, allow, allowUser, logic, noMatch = null, permCheck, children } = this.props;
    if (reject || !account || account.saleStatus?.authorized === false) {
      return noMatch;
    }

    if (allow) {
      return children;
    }

    if (allowUser && allowUser === account.saleStatus?.userId) {
      return children;
    }

    if (permCheck && !permCheck(account)) {
      return noMatch;
    }

    if (allOf && !account.allOf(allOf)) {
      return noMatch;
    }

    if (oneOf && !account.oneOf(oneOf)) {
      return noMatch;
    }

    if (notOf && account.oneOf(notOf)) {
      return noMatch;
    }

    return children;
  }
}

export function withPermHoc(Component, permOptions = {}) {
  return (props) => (
    <WithPermission {...permOptions}>
      <Component {...props} />
    </WithPermission>
  );
}

export default WithPermission;
